import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';

// Lodash
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';

// Components
import PinAction from './atoms/pinAction';
import ActionsMenu from './atoms/actionsMenu';

// Helpers
import { getPinActionAndMenuActions } from './actionButtons.helpers';
import styles from './actionButtons.module.scss';
var ActionButtons = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionButtons, _PureComponent);
  var _super = _createSuper(ActionButtons);
  function ActionButtons() {
    var _this;
    _classCallCheck(this, ActionButtons);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getPinActionAndMenuActions", defaultMemoize(getPinActionAndMenuActions));
    _defineProperty(_assertThisInitialized(_this), "handleRowAction", function (value) {
      var actions = _this.props.actions;
      var handleAction = _get(_find(actions, {
        key: value
      }), 'onClick', _noop);
      handleAction();
    });
    return _this;
  }
  _createClass(ActionButtons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        actions = _this$props.actions,
        placement = _this$props.placement;
      var _this$getPinActionAnd = this.getPinActionAndMenuActions(actions),
        pinAction = _this$getPinActionAnd.pinAction,
        menuActions = _this$getPinActionAnd.menuActions;
      var showPinAction = !_isEmpty(pinAction);
      var showActionMenu = !_isEmpty(menuActions);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.actionButtons, " ").concat(className)
      }, showPinAction && /*#__PURE__*/React.createElement(PinAction, {
        pinAction: pinAction
      }), showActionMenu && /*#__PURE__*/React.createElement(ActionsMenu, {
        menuItems: menuActions,
        placement: placement,
        onClickAction: this.handleRowAction
      }));
    }
  }]);
  return ActionButtons;
}(PureComponent);
ActionButtons.propTypes = {
  actions: PropTypes.array.isRequired,
  placement: PropTypes.string,
  className: PropTypes.string
};
ActionButtons.defaultProps = {
  placement: 'bottomLeft',
  className: ''
};
export default ActionButtons;